import React from "react";
import { Box, Stack, Typography } from "@mui/material";
import { HEADER_HEIGHT } from "../../../../utils/ui.constants";
import IConButtonApp from "../../IconButtonApp/IConButtonApp";
import UserSetting from "./UserSetting";
import GlobalSearch from "./GlobalSearch";
import { LuBellRing, LuMaximize, LuMenu } from "react-icons/lu";

interface IHeader {
  toggleSideBar?: () => void;
}

function Header({ toggleSideBar }: IHeader) {
  const openFullScreen = () => {
    const el = document.documentElement;
    if (!el) return;
    if (el.requestFullscreen) {
      el.requestFullscreen();
    }
  };

  return (
    <Box
      component="header"
      sx={{
        width: "100%",
        height: HEADER_HEIGHT,
        py: 1,
        backgroundColor: "background.paper",
      }}
    >
      <Stack
        sx={{ width: "100%", height: "100%" }}
        direction="row"
        alignItems="center"
        justifyContent="space-between"
      >
        <Stack
          direction="row"
          alignItems="center"
          justifyContent="space-between"
          sx={{ flex: 1, pl: 2 }}
        >
          <Typography sx={{ fontSize: "20px", fontWeight: 600 }}>
            Data Analytics
          </Typography>
          <IConButtonApp onClick={toggleSideBar}>
            <LuMenu size={20} />
          </IConButtonApp>
        </Stack>
        <Stack
          direction="row"
          alignItems="center"
          justifyContent="space-between"
          sx={{ width: "calc(100% - 260px)", height: "100%", px: 2 }}
        >
          <Stack direction="row" alignItems="center" sx={{ flex: 1 }}>
            <Box sx={{ width: "60%", maxWidth: "430px" }}>
              <GlobalSearch />
            </Box>
          </Stack>
          <Stack direction="row" alignItems="center" gap={2}>
            <IConButtonApp>
              <LuBellRing size={20} />
            </IConButtonApp>
            <IConButtonApp
              onClick={openFullScreen}
              sx={{
                backgroundColor: "primary.600",
                color: "primary.main",
                "&:hover": {
                  backgroundColor: "primary.main",
                  color: "common.white",
                },
              }}
            >
              <LuMaximize size={20} />
            </IConButtonApp>
            <UserSetting />
          </Stack>
        </Stack>
      </Stack>
    </Box>
  );
}

export default Header;
